var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "jump-to-nav",
    {
      staticClass: "laptop:position-sticky-top laptop:padding-top-2xl",
      attrs: { title: "On This Page" },
    },
    [
      _c(
        "list",
        { attrs: { "has-divider": "" } },
        [
          _c("list-item", { attrs: { hash: "#about" } }, [
            _vm._v("What is Font Awesome?"),
          ]),
          _vm._v(" "),
          _c("list-item", { attrs: { hash: "#collection" } }, [
            _vm._v("How does Font Awesome collect data about me?"),
          ]),
          _vm._v(" "),
          _c("list-item", { attrs: { hash: "#data" } }, [
            _vm._v("What data does Font Awesome collect about me, and why?"),
          ]),
          _vm._v(" "),
          _c("list-item", { attrs: { hash: "#choice" } }, [
            _vm._v("How can I make choices about data collection?"),
          ]),
          _vm._v(" "),
          _c("list-item", { attrs: { hash: "#locality" } }, [
            _vm._v("Where does Font Awesome store data about me?"),
          ]),
          _vm._v(" "),
          _c("list-item", { attrs: { hash: "#gdpr" } }, [
            _vm._v(
              "Does Font Awesome comply with the EU General Data Protection Regulation?"
            ),
          ]),
          _vm._v(" "),
          _c("list-item", { attrs: { hash: "#access" } }, [
            _vm._v("Where can I see, change, and erase data about me?"),
          ]),
          _vm._v(" "),
          _c("list-item", { attrs: { hash: "#sharing", "is-last": "" } }, [
            _vm._v(
              "\n      Does Font Awesome share data about me with others?\n    "
            ),
          ]),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "list",
        { attrs: { "has-divider": "" } },
        [
          _c("list-item", { attrs: { hash: "#contact" } }, [
            _vm._v("How can I contact Font Awesome about privacy?"),
          ]),
          _vm._v(" "),
          _c("list-item", { attrs: { hash: "#changes", "is-last": "" } }, [
            _vm._v("\n      How can I find out about changes?\n    "),
          ]),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "list",
        { attrs: { "has-divider": "" } },
        [
          _c("list-item", { attrs: { hash: "#cdn-providers" } }, [
            _vm._v("Content Delivery Network Providers"),
          ]),
          _vm._v(" "),
          _c("list-item", { attrs: { hash: "#payment-processors" } }, [
            _vm._v("Payment Processors"),
          ]),
          _vm._v(" "),
          _c(
            "list-item",
            { attrs: { hash: "#other-services", "is-last": "" } },
            [_vm._v("\n      Other Services\n    ")]
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "list",
        [
          _c("list-item", { attrs: { hash: "#dpf-details" } }, [
            _vm._v("EU-U.S. Data Protection Framework Statement and Policy"),
          ]),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }